import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export async function setClientAdvanced(data) {
    const { crmCompanyId, id, excludeFromReporting } = data
    return mutate(
        gql`
            mutation setClientAdvanced($crmCompanyId: String, $id: String, $excludeFromReporting: Boolean) {
                setClientAdvanced(crmCompanyId: $crmCompanyId, id: $id, excludeFromReporting: $excludeFromReporting)
            }
        `,
        { crmCompanyId, id, excludeFromReporting },
        { returns: "updateClientAdvanced" }
    )
}
